import Title from "@/components/Title";
import {
  useRecommendationAPI,
  useRecommendationExistenceAPI,
} from "@/components/report/disease_risk/apis";
import {
  RecommendationExistenceInfo,
  RecommendationInfo,
  V1RecommendationInfo,
  V2RecommendationInfo,
  isV1RecommendationInfo,
  isV2RecommendationInfo,
} from "@/components/report/disease_risk/commons";
import DiseaseRiskReportV1 from "@/components/report/disease_risk/disease_risk_v1/DiseaseRiskReport";
import DiseaseRiskReportV2 from "@/components/report/disease_risk/disease_risk_v2/DiseaseRiskReport";
import { examineeTheme } from "@/theme/themeV1";
import { ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function DiseaseRiskPage() {
  const { uuid } = useParams();
  const recommendationAPI = useRecommendationAPI();
  const recommendationExistenceAPI = useRecommendationExistenceAPI();

  const [recommendation, setRecommendation] = useState<RecommendationInfo>();
  const [recommendationExistenceInfo, setRecommendationExistenceInfo] =
    useState<RecommendationExistenceInfo>();

  useEffect(() => {
    (async () => {
      if (uuid == null) return;
      const response = await recommendationAPI.get(uuid);
      setRecommendation(response.data);
    })();
  }, [recommendationAPI, uuid]);

  useEffect(() => {
    (async () => {
      if (uuid == null) return;
      const response = await recommendationExistenceAPI.get(uuid);
      setRecommendationExistenceInfo(response.data);
    })();
  }, [recommendationExistenceAPI, uuid]);

  if (recommendation == null || recommendationExistenceInfo == null)
    return <></>;
  return (
    <ThemeProvider theme={examineeTheme}>
      <>
        <Title title="SLEEP COMPASS" />
        <meta
          name="description"
          content="専用デバイスによる、自宅でできる8日間の睡眠測定。高精度のアルゴリズムで眠れない理由を明らかにします。"
        />
      </>
      {isV1RecommendationInfo(recommendation) && (
        <DiseaseRiskReportV1
          data={recommendation as V1RecommendationInfo}
          existence={recommendationExistenceInfo}
        />
      )}
      {isV2RecommendationInfo(recommendation) && (
        <DiseaseRiskReportV2
          data={recommendation as V2RecommendationInfo}
          existence={recommendationExistenceInfo}
        />
      )}
    </ThemeProvider>
  );
}
